import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { MDBSwitch } from "mdb-react-ui-kit";
import AlertsComp from "../../Components/AlertsComp";
import { Camelcase, HideLoder, LogInUserID, ShowLoder, transformNameOfCol, formatDateToUsaMMDDYYYY, CamelCaseWithSpaces, BucketS3Link } from "../../JS/Common";
import { ApiGetCall, ApiGetHeaders, ApiPostCall } from "../../JS/Connector";
import { staffdetailscontent } from ".";
import { useContext } from "react";
import Pagination from "react-js-pagination";
import { Logout } from "../Signout";
import CustomizationPopup from "../../Components/CustomizationPopup";
import Popup from "../../Components/Popup";
import Deletepopup from "../../Components/Deletepopup";
import { CheckValidation } from "../../Components/Validations";
import { useSelector } from "react-redux";
import useConfig from "../../Hooks/useConfig";
import { useStickyAction } from "../../Hooks";

export function StaffAddUpdate(props) {
    const { dynamic_brand_text } = useConfig();
    const { allData, setAllData } = useContext(staffdetailscontent);
    const StateData = useSelector((state) => state.authData);
    const [isShow, setisShow] = useState(false);
    const [isOwnerShipTransfer, setisOwnerShipTransfer] = useState(false);
    const [NewAlerts, setNewAlerts] = useState("");
    const [loading, setLoading] = useState(false);
    const [CustomizationModal, setCustomizationModal] = useState(false)
    const [deleteusershow, setdeleteusershow] = useState(false);
    const [deleteuserid, setdeleteuserid] = useState(null);
    const [transferId, setTransferId] = useState(null);
    const { tableWrapperRef, isOverflowing } = useStickyAction(props.columnNames);

    useEffect(() => {
        const selectedArray = [
            ...props.selectedIdsAll.map((id) => ({ id })),
        ];
        const idAndSubtotalArray = selectedArray.map(({ id }) => ({ id: id }));
        props.setSelectedItems(idAndSubtotalArray);
        if (idAndSubtotalArray.length === 0) {
            props.setCreateGroupModal(false)
            props.setCreateBatchbuttonVisible(false)
        }
    }, [props.selectedIdsAll])
    useEffect(() => {
        props.GetAccessDevice(props?.allData?.skey || null, null, false);
        ApiGetHeaders(3, props.setColumnNames)
    }, []);
    function renderContentForColumn(columnName, item) {
        const contentMap = {
            "avatar": item.profile ? <img src={item.profile} height='25px' width="25px" style={{ borderRadius: "50%" }} /> : <img src={`${BucketS3Link}avtar/${item.avatarimg}`} height='25px' />,
            "Name": item.first_name && (Camelcase(item.first_name + ' ' + item.last_name)) || '-',
            "access_type": item?.accesstype?.name || '-',
            "email": item.email || '-',
            "created_at": formatDateToUsaMMDDYYYY(item.created_at) || '-'
        };
        return contentMap[columnName] || null;
    }
    async function DeactivateStaff(memberid, flag) {
        var loginuserid = LogInUserID;
        setLoading(true);
        var raw = JSON.stringify({
            id: memberid,
            flag: flag
        })
        await ApiPostCall("/users/delete", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                setisShow(false);
                const responseRs = JSON.parse(result);
                if (responseRs.status == "success") {
                    var msg = flag == 1 ? 'User Activated Successfully' : 'User Deactivated Successfully';
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={msg} />);
                    if (loginuserid == memberid) {
                        Logout();
                    } else {
                        setTimeout(() => {
                            setNewAlerts(<AlertsComp show={false} />)
                            props.GetAccessDevice(props?.allData?.skey || null, null, false);
                        }, 2000);
                    }

                } else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />)
                    }, 2000);
                }
            }
        })
    }
    function handleChange(e, memberid, itemstatus) {
        const { name, checked } = e.target;

        let tempuser = props.CurrentUsers.map(user =>
            user.name === name ? { ...user, isChecked: checked } : user
        );
        props.setUsers(tempuser);

        setAllData({ ...allData, Memberid: memberid })

        if (itemstatus == 1) {
            setisShow(true);
        } else {
            DeactivateStaff(memberid, 1);
        }
    }
    async function GetUserbyid(itemid) {
        setLoading(true);
        await ApiGetCall(`/users/by-id?userId=${itemid}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                const responseRs = JSON.parse(result);
                setAllData({
                    ...allData, firstname: responseRs.msg[0].first_name, lastname: responseRs.msg[0].last_name,
                    email: responseRs.msg[0].email, access: responseRs.msg[0].access_type_id, flag: 2, Memberid: itemid,
                    File: responseRs.msg[0].profile ? responseRs.msg[0].profile : `${BucketS3Link}avtar/${responseRs.msg[0].avtar_details}`
                })
            }
        });
    }
    function handleHeaderCheckboxChange(e, flag) {
        props.setCreateBatchbuttonVisible(true)
        const isChecked = e.target.checked;
        if (flag == "all") {
            props.setSelectedIdsAll(
                isChecked ? props.CurrentUsers.map((item) => item.id) : []
            );
        }
    };
    function handleCheckboxChange(e, flag, ID) {
        const isChecked = e.target.checked;
        props.setCreateBatchbuttonVisible(true)
        if (flag == "all") {
            props.setSelectedIdsAll((prevIds) => {
                if (isChecked) {
                    return [...prevIds, ID];
                } else {
                    return prevIds.filter((id) => id !== ID);
                }
            });
        }
    }
    async function DeleteUser() {
        setLoading(true);
        var raw = JSON.stringify({
            id: deleteuserid,
            flag: 3
        })
        await ApiPostCall("/users/delete", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                setisShow(false);
                const responseRs = JSON.parse(result);
                setdeleteusershow(false);
                if (responseRs.status == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={`${dynamic_brand_text} User Deleted Successfully.`} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />)
                        props.GetAccessDevice(null, null, false);
                    }, 2000);

                } else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />)
                    }, 2000);
                }
            }
        })
    }
    const transferOwnerShipBody = (
        <div className="row parent" id="TransferOwenrshipDiv">
            <div className="col-12 py-2">
                <select required value={transferId} onChange={(e) => setTransferId(e.target.value)}>
                    <option value="0">Select {dynamic_brand_text} Users</option>
                    {props?.CurrentUsers
                        ?.filter(user => user.id != deleteuserid) // Filter out the user you want to exclude
                        .map((item, i) => (
                            <option value={item.id} key={i}>{item.first_name} {item.last_name}</option>
                        ))
                    }
                </select>
                <span className="form-text invalid-feedback">
                    *required
                </span>
            </div>
        </div>
    )
    const handleTransferOwenership = async () => {
        var isFormValid = CheckValidation({ formID: 'TransferOwenrshipDiv' });
        if (!isFormValid) return;
        setLoading(true);
        var raw = JSON.stringify({
            oldUserId: deleteuserid,
            newUserId: transferId
        });
        await ApiPostCall("/users/transfer-ownership", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                if (result == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={"Ownership Transfer Successfully."} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />);
                        setisOwnerShipTransfer(false)
                        setTransferId(null);
                        setdeleteuserid(null);
                        props.GetAccessDevice(props?.allData?.skey || null, null, false);
                    }, 2500);
                }
                else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />)
                    }, 1000);
                }
            }
        });
    }
    return (
        <>
            {NewAlerts}
            {loading ? <ShowLoder /> : <HideLoder />}
            <div className="data-table-container" ref={tableWrapperRef}>
                <table className="table data-table">
                    <thead className='GridHeader'>
                        <tr>
                            {props?.CurrentUsers?.length > 0 &&
                                <th scope="col">
                                    <input className='form-check-input' type="checkbox"
                                        checked={props?.CurrentUsers?.length > 0 ? props?.selectedIdsAll?.length === props?.CurrentUsers?.length : false}
                                        onChange={(e) => handleHeaderCheckboxChange(e, "all")} />
                                </th>
                            }
                            {props.columnNames?.map((item) => {
                                const columnName = item.replace(/_/g, ' ');
                                const transformedName = transformNameOfCol(columnName);
                                if (!transformedName) return null;
                                return (
                                    item != 'avatar' && item != 'access_type' ?
                                        <th key={item} scope="col" className='cursor-pointer fw-600' title={`Sort by ${CamelCaseWithSpaces(transformedName)}`} onClick={(e) => props.GetAccessDevice(item == 'Name' ? 'first_name' : item, allData.searchstring, true)}>
                                            {Camelcase(transformedName)}
                                            <img src="/images/sortbynew.svg" alt={`Sort by ${transformedName}`} className="img-fluid ps-2 sortbyClass" />
                                        </th>
                                        :
                                        <th key={item} scope="col" className='fw-600'>
                                            {Camelcase(transformedName)}
                                        </th>
                                )
                            })}
                            <th scope="col" className="text-center fw-600">Status</th>
                            <th scope="col" className={`text-center fw-600 cursor-pointer ${isOverflowing ? 'sticky-action' : ''}`}>
                                <div className="d-flex">
                                    Action
                                    <div className="EditHeaderIconDiv">
                                        <img src="/images/EditHeaderIcon.svg" className="img-fluid ps-2" title='Customize Headers' style={{ height: '25px' }} onClick={(e) => setCustomizationModal(true)} />
                                    </div>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.CurrentUsers?.length != 0 ? (
                            props.CurrentUsers?.map((item, i) => {
                                return (<tr key={i} className={`OddEvenClass tableBorderHide ${item.ownership_status == 1 && 'blueText'} ${item.statusFlag}`}>
                                    <td className="py-12">
                                        <input className='form-check-input' type="checkbox" checked={props.selectedIdsAll.includes(item.id)} onChange={(e) => handleCheckboxChange(e, "all", item.id)} batchid={item.id} />
                                    </td>
                                    {props.columnNames?.map(header => (
                                        <td className="py-12" key={header}>
                                            {renderContentForColumn(header, item)}
                                        </td>
                                    ))}
                                    <td className="text-center py-12">
                                        <MDBSwitch className="BgPink cursor-pointer"
                                            name={item.name} memberid={item.id} itemstatus={item.status}
                                            checked={item.status == 1 ? item?.isChecked || true : item?.isChecked || false}
                                            onChange={(e) => handleChange(e, item.id, item.status)}
                                        />
                                    </td>
                                    <td className={`text-center py-12 ${isOverflowing ? 'sticky-action' : ''}`}>

                                        {item.status == 1 ?
                                            <img src="/images/EditIconNew.svg" className="img-fluid cursor-pointer" title={`Edit ${dynamic_brand_text} User`} onClick={(e) => { props.setIsaddupadtepopup(true); GetUserbyid(item.id) }} staffmemberid={item.id} />
                                            :
                                            <img src="/images/DisableEditIcon.svg" className="img-fluid" />
                                        }
                                        {item.ownership_status == 1 ?
                                            <img src="/images/transfer_ownership.svg" title="Transfer Ownership" className="img-fluid cursor-pointer ps-2" onClick={(e) => { setisOwnerShipTransfer(true); setdeleteuserid(item.id) }} />
                                            :
                                            item.is_school_admin != 1 && item.id != LogInUserID && <img src="/images/DeleteIcon.svg" title={`Delete ${dynamic_brand_text} User`} className="img-fluid cursor-pointer ps-2" onClick={(e) => { setdeleteusershow(true); setdeleteuserid(item.id) }} />
                                        }
                                    </td>
                                </tr>
                                )
                            }))
                            :
                            <tr className="col-12 text-center p-2"><td colSpan={10}>No Record Found</td></tr>
                        }
                    </tbody>
                </table>
            </div>
            {props.showPagination && (
                <Pagination activePage={props.currentPage} totalItemsCount={props.pageRangeCount}
                    pageRangeDisplayed={15} itemsCountPerPage={props.LimitForPagination} onChange={(e) => props.setCurrentPage(e)}
                    color="primary" lastPageText="" firstPageText="" itemClassFirst="MasterClass" itemClassPrev="MasterClass"
                    itemClassNext="MasterClass" itemClassLast="MasterClass" hideFirstLastPages={true} />
            )}
            <Popup isshow={isShow} size={"md"} title={`Deactivate ${dynamic_brand_text} User`}
                closePopup={(e) => { setisShow(false) }}
                modalBody={"Are you sure want to deactivate this member?"} handleSave={(e) => DeactivateStaff(allData.Memberid, "2")} visibleSaveBtn={true} btnText={"Yes"} />

            {CustomizationModal == true && (
                <CustomizationPopup isShow={CustomizationModal} setCustomizationModal={setCustomizationModal} gridname={`${dynamic_brand_text} Users`} modalSize={'lg'} GetCall={(e) => ApiGetHeaders(3, props.setColumnNames)} />
            )}
            <Deletepopup text={`You won't be able to revert this!`} deletePopup={deleteusershow} deletePart={DeleteUser} DeleteShowClose={(e) => setdeleteusershow(false)}></Deletepopup>
            <Popup isshow={isOwnerShipTransfer} size={"md"} title={"Transfer Ownership"}
                closePopup={(e) => { setisOwnerShipTransfer(false) }}
                modalBody={transferOwnerShipBody}
                handleSave={handleTransferOwenership}
                visibleSaveBtn={true} btnText={"Transfer"} />
        </>

    )
}
